class TributacoesItensModal {
    get $inject() {
        return ['$scope', 'gql', 'downloadService'];
    }

    constructor($scope, gql, downloadService) {
        this.apply = fn => $scope.$apply(fn);
        this.gql = gql;
        this.downloadService = downloadService;
    }

    $onInit() {
        this.promise = this
            .listTributacoesItens(this.resolve.codigoBarras)
            .then(itens => this.tributacoesItens = itens)
            .catch(console.error);
    }

    listTributacoesItens(codigoBarras) {
        const query = gql`
            query TributacoesItens($codigoBarrasIs: String!) {
                icmsTributacoesItens(codigoBarrasIs: $codigoBarrasIs) {
                    id
                    tipoReceita
                    confiavel
                    percentual
                    tributacao {
                        id
                        nfe {
                            id
                        }
                    }
                    icmsExtratoItem {
                        id
                        ncm
                        cest
                    }
                }
            }
        `

        return this.gql
            .query(query, { codigoBarrasIs: codigoBarras })
            .then(({ icmsTributacoesItens }) => icmsTributacoesItens)
    }

    danfe(tributacaoItem, codigoBarras) {
        const query = gql`
            query TributacoesItens($id: String!, $codigoBarrasIs: String!) {
                icmsTributacoesItens(id: $id, codigoBarrasIs: $codigoBarrasIs) {
                    id
                    tributacao {
                        id
                        nfe {
                            id
                            danfe { token }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { id: tributacaoItem.id, codigoBarrasIs: codigoBarras })
            .then(({ icmsTributacoesItens }) => icmsTributacoesItens[0].tributacao.nfe.danfe.token)
            .then(token => this.downloadService.download(`/resume-operation/${token}`))
            .catch(console.error)
    }
}

angular
    .module("eficienciaFiscalModule")
    .component("tributacoesItensModal", {
        controller: TributacoesItensModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Tributações de itens" close="$ctrl.close">
                <modal-body>
                    <div class="clearfix">
                        <highlighted>
                            <main>Tributações de itens.</main>
                            <secondary ng-if="$ctrl.tributacoesItens.length">Abaixo estão as tributações de itens do código de barras: <b>{{$ctrl.resolve.codigoBarras}}</b>.</secondary>
                            <secondary ng-if="!$ctrl.tributacoesItens.length">Nenhuma tributação encontrada para o código de barras: <b>{{$ctrl.resolve.codigoBarras}}</b>.</secondary>
                        </highlighted>
                        
                        <loading promise="$ctrl.promise">
                            <table ng-if="$ctrl.tributacoesItens.length" class="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Tipo de receita</th>
                                        <th>Percentual</th>
                                        <th>NCM</th>
                                        <th>CEST</th>
                                        <th class="text-left">Confiabilidade</th>
                                        <th></th>
                                    </tr>
                                </thead>   
                                <tbody>
                                    <tr ng-repeat="tributacaoItem in $ctrl.tributacoesItens">
                                        <td>{{tributacaoItem.tipoReceita}}</td>
                                        <td class="text-left">{{tributacaoItem.percentual | number: 2 }}%</td>
                                        <td>{{tributacaoItem.icmsExtratoItem.ncm ? tributacaoItem.icmsExtratoItem.ncm : '--' }}</td>
                                        <td>{{tributacaoItem.icmsExtratoItem.cest ? tributacaoItem.icmsExtratoItem.cest : '--' }}</td>
                                        <td class="text-left">
                                            <span class="label label-success" ng-show="tributacaoItem.confiavel">
                                                CONFIÁVEL
                                            </span>
                                            <span class="label label-danger" ng-hide="tributacaoItem.confiavel">
                                                NÃO CONFIÁVEL
                                            </span>
                                        </td>
                                        <td>
                                            <a 
                                                href="javascript:void(0)" 
                                                ng-click="$ctrl.danfe(tributacaoItem, $ctrl.resolve.codigoBarras)">
                                                DANFE
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>   
                            </table>
                        </loading>
                    </div>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
